import JobLevel from "../../components/JobLevel/JobLevel";
import Dashrightright from "../Dashrightright/Dashrightright";
import { useRecoilValue } from "recoil";
import { jobLevelCycle } from "../../atoms/dashboard";
import { myCareerWheel } from "../../selectors/dashboard";
import { useEffect } from "react";

const Dashright = ({ details }) => {
  const myCareerWheelData = useRecoilValue(myCareerWheel);

  useEffect(() => {
    if (myCareerWheelData == "No record found") {
      const theContent = document.querySelectorAll("div.my-role.active");
      theContent[0]?.classList.remove("active");
      const divMyjourney = document.querySelectorAll("div.my-journey");
      divMyjourney[0]?.classList.add("active");
      console.log(divMyjourney);
    }
  });

  return (
    <>
      <div className="flex justify-between h-full">
        {myCareerWheelData != "No record found1" ? (
          <JobLevel />
        ) : (
          "No Record found"
        )}
        <Dashrightright details={details} />
      </div>
    </>
  );
};

export default Dashright;
